import settings from '@/data/constants';

import { requestHeaders } from '../api.utils';

import type {
  FilteredProductsPayloadType,
  ProductByDeviceResponse,
  ProductFilteredResponse
} from './filteredProducts.types';

export const buildFilteredProductsByDoctorUrl = ({
  doctorId,
  isConcession = false,
  patientId
}: FilteredProductsPayloadType): string => {
  let url = `${settings.url}/product/filtered/by-doctor/${doctorId}`;

  // append isConcession as false by default
  url += `?isConcession=${isConcession}`;

  if (patientId) {
    url += `&patientId=${patientId}`;
  }

  return url;
};

export const fetchFilteredProductsByDoctor = async ({
  doctorId,
  isConcession,
  patientId
}: FilteredProductsPayloadType): Promise<ProductFilteredResponse> => {
  const filteredProductsUrl = buildFilteredProductsByDoctorUrl({ doctorId, isConcession, patientId });

  const response = await (
    await fetch(filteredProductsUrl, {
      method: 'GET',
      headers: requestHeaders()
    })
  ).json();
  return response;
};

/**
 * Used for getting vaporizer.
 */
export const fetchFilteredProductsByDoctorByDevice = async ({
  doctorId
}: FilteredProductsPayloadType): Promise<ProductByDeviceResponse> => {
  const response = await (
    await fetch(`${settings.url}/product/filtered/device/by-doctor/${doctorId}`, {
      method: 'GET',
      headers: requestHeaders()
    })
  ).json();
  return response;
};
